import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import Box from './Box'
import { Discount } from '../../../pure-js/types/DiscountTypes'
import { Activity, Client } from '../../../pure-js/types/GrooverTypes'
import { resolveActivityPageFieldVisibility } from '../../../pure-js/libs/clientHelper'
import { getActiveDiscounts } from '../../../pure-js/libs/DiscountHelper'
import RegistrationDiscountDisplay from './RegistrationDiscountDisplay'
import GrooverText from './GrooverText'
import { formatGrooverText, getGrooverText } from '../libs/GrooverTextRepository'
import { useCurrency } from '../hooks/useCurrency'
import { formatPrice } from '../utils/activityUtils'
import useAppState from '../hooks/useAppState'

interface ActivityInfoProps {
  activity: Activity
  client?: Client
}

const RegistrationPrice: React.FC<ActivityInfoProps> = ({ activity, client }) => {
  const [matchedDiscounts, setMatchedDiscounts] = useState<Discount[]>([])
  const currency = useCurrency(client)
  const { state } = useAppState()
  const language = state.user?.language
  const visibility = resolveActivityPageFieldVisibility(client)

  const getMatchedDiscounts = (): Discount[] => {
    if (!client || !activity.discountIds || !Array.isArray(activity.discountIds)) return []

    const activeDiscounts = getActiveDiscounts(client.discounts).filter((d) => d.type !== 'code')
    return activity.discountIds
      .map((discountId) => activeDiscounts.find((discount) => discount.id === discountId))
      .filter(Boolean) as Discount[]
  }

  useEffect(() => {
    if (activity && client) {
      setMatchedDiscounts(getMatchedDiscounts())
    }
  }, [activity, client])

  return (
    <SegmentContainer fullWidth>
      <GrooverText textKey="externalActivityPageSegmentPriceHeader" language={language} />
      <Box direction="row" fullWidth justify="flex-start" gap="16px" align="center">
        {visibility.showPrice && (
          <PriceText>
            {activity.price
              ? formatPrice(activity.price, currency)
              : getGrooverText('userWeb.activityDetail.price.free', language)}
          </PriceText>
        )}
        {visibility.showDropinPrice && activity.priceAtDoor ? (
          <PriceTextAtDoor>
            {formatGrooverText(getGrooverText('externalActivityPageSegmentPricePriceAtTheDoor', language), [
              Math.round((activity.priceAtDoor ?? 0) / 100)
            ])}
          </PriceTextAtDoor>
        ) : null}
      </Box>

      {visibility.showPrice && !((client && client.hideDiscountsInPublicPage) || !activity.price) ? (
        <RegistrationDiscountDisplay matchedDiscounts={matchedDiscounts} currency={currency} client={client} />
      ) : null}
    </SegmentContainer>
  )
}

const SegmentContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-sizing: border-box;
`

const PriceText = styled(Box)`
  margin-top: 8px;
  font-size: 16px;
  color: #333;
  margin-bottom: 16px;
`

const PriceTextAtDoor = styled(Box)`
  margin-top: 8px;
  font-size: 16px;
  color: #e99243;
  margin-bottom: 16px;
  padding: 8px 6px;
  border-radius: 6px;
  border: 1px solid #e99243;
`
export default RegistrationPrice
